import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();

console.log('🌙 [DARK THEME] Build v71.0-DARK-NUCLEAR loaded at:', new Date().toISOString());
console.log('🌙 [DARK THEME] If you see this, the NEW JS bundle is loaded');
console.log('🌙 [DARK THEME] CSS file:', document.querySelector('link[href*="main"]')?.getAttribute('href'));

// Debug: check computed background colors
setTimeout(() => {
  const body = document.body;
  const root = document.getElementById('root');
  const bodyBg = getComputedStyle(body).backgroundColor;
  const rootBg = root ? getComputedStyle(root).backgroundColor : 'N/A';
  console.log('🎨 [DARK DEBUG] body background:', bodyBg);
  console.log('🎨 [DARK DEBUG] #root background:', rootBg);
  console.log('🎨 [DARK DEBUG] Expected: rgb(26, 29, 46) = #1a1d2e');

  // Check if dark theme CSS variables are set
  const styles = getComputedStyle(document.documentElement);
  console.log('🎨 [DARK DEBUG] --background-color:', styles.getPropertyValue('--background-color'));
  console.log('🎨 [DARK DEBUG] --card-color:', styles.getPropertyValue('--card-color'));
  console.log('🎨 [DARK DEBUG] --text-color:', styles.getPropertyValue('--text-color'));
  console.log('🎨 [DARK DEBUG] --border-color:', styles.getPropertyValue('--border-color'));

  // Check MUI card backgrounds
  const cards = document.querySelectorAll('.MuiCard-root');
  if (cards.length > 0) {
    const cardBg = getComputedStyle(cards[0]).backgroundColor;
    console.log('🎨 [DARK DEBUG] First MuiCard background:', cardBg);
    console.log('🎨 [DARK DEBUG] Expected card bg: rgb(37, 40, 56) = #252838');
  }

  // Check MUI Paper backgrounds
  const papers = document.querySelectorAll('.MuiPaper-root');
  if (papers.length > 0) {
    const paperBg = getComputedStyle(papers[0]).backgroundColor;
    console.log('🎨 [DARK DEBUG] First MuiPaper background:', paperBg);
  }

  // Check all stylesheets loaded
  const sheets = document.querySelectorAll('link[rel="stylesheet"]');
  console.log('🎨 [DARK DEBUG] Loaded stylesheets:', sheets.length);
  sheets.forEach((s, i) => {
    console.log(`  📄 [${i}]:`, s.getAttribute('href'));
  });
}, 3000);

